import { _ as _slicedToArray, h as _extends } from './_rollupPluginBabelHelpers-f5c57928.js';
import React__default, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { u as useComponentWidth } from './useComponentWidth-f74aea3c.js';
import { u as usePrevious } from './usePrevious-edd83563.js';
import { P as PropertyCard, a as alternativeOffersLabelsShape } from './index-16974fec.js';
import Title from './Title.js';
import EmptySectionMessage from './EmptySectionMessage.js';
import { e as multiPropertyOfferShape, c as currencyShape, g as feedbackMessagesShape, f as formattedSearchParamsShape, h as trustYouReducerShape, n as nodeOrStringProp } from './PropTypes-9aad034b.js';
import './Card-683c5834.js';
import './Image.js';
import './Modal.js';
import 'react-dom';
import './ModalHeader-daaa2bf6.js';
import './Icon.js';
import './_commonjsHelpers-97e6d7b1.js';
import './tslib.es6-2748fcb6.js';
import 'moment';
import './MapView.js';
import './Location.js';
import './AmenitiesList.js';
import './Description.js';
import './Price.js';
import './index-c101e2b0.js';
import './useIntl-2030d1c8.js';
import './injectIntl-0da7053c.js';
import './hoist-non-react-statics.cjs-596f6afc.js';
import './index-c093c499.js';
import './provider-b3aa55fe.js';
import './Label.js';
import './Button-9db40655.js';
import './utilsHelpers-21a239d9.js';
import './LoadingBlock.js';
import './PropertyRating.js';
import './LoadingSpinner.js';
import './handleOpenLink-49ba3691.js';
import './Divider.js';

function PropertiesList(props) {
  var _usePrevious;
  var availableProperties = props.availableProperties,
    notAvailableProperties = props.notAvailableProperties,
    className = props.className,
    displayMode = props.displayMode,
    alternativeGrid = props.alternativeGrid,
    isLoading = props.isLoading,
    showFeedbackMessage = props.showFeedbackMessage,
    propertyCardProps = props.propertyCardProps,
    params = props.params,
    domain = props.domain,
    getQueryString = props.getQueryString,
    feedbackMessages = props.feedbackMessages,
    onClick = props.onClick,
    styledPrice = props.styledPrice,
    priceMessages = props.priceMessages,
    onPropertiesRendered = props.onPropertiesRendered,
    userCountry = props.userCountry,
    trustYou = props.trustYou,
    isQA = props.isQA,
    hidePrices = props.hidePrices,
    hidePricesMessage = props.hidePricesMessage,
    alternativeOffersLabels = props.alternativeOffersLabels,
    intl = props.intl;
  var previousLength = ((_usePrevious = usePrevious(availableProperties)) === null || _usePrevious === void 0 ? void 0 : _usePrevious.length) || 0;
  var getColumnsNumberByDisplayMode = useCallback(function () {
    return displayMode === 'list' ? 1 : 3;
  }, [displayMode]);
  var _useComponentWidth = useComponentWidth(),
    _useComponentWidth2 = _slicedToArray(_useComponentWidth, 2),
    rootRef = _useComponentWidth2[0],
    rootWidth = _useComponentWidth2[1];
  var getColumnsNumberByResize = useCallback(function () {
    if (rootRef.current && displayMode === 'grid') {
      if (rootWidth >= 900) {
        return 3;
      }
      if (rootWidth < 900 && rootWidth >= 768) {
        return 2;
      }
      if (rootWidth < 768) {
        return 1;
      }
    }
    return 1;
  }, [displayMode, rootRef, rootWidth]);
  var _useState = useState(getColumnsNumberByDisplayMode),
    _useState2 = _slicedToArray(_useState, 2),
    propertiesListColumns = _useState2[0],
    setPropertiesListColumns = _useState2[1];
  useEffect(function () {
    var shouldRun = onPropertiesRendered && (availableProperties === null || availableProperties === void 0 ? void 0 : availableProperties.length) && previousLength !== availableProperties.length;
    if (shouldRun) {
      onPropertiesRendered('Hotel List', availableProperties === null || availableProperties === void 0 ? void 0 : availableProperties.length);
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [availableProperties]);
  useEffect(function () {
    return setPropertiesListColumns(getColumnsNumberByDisplayMode);
  }, [displayMode, getColumnsNumberByDisplayMode]);
  useEffect(function () {
    return setPropertiesListColumns(getColumnsNumberByResize);
  }, [rootWidth, getColumnsNumberByResize]);
  var availablePropertiesExist = !isLoading && (availableProperties === null || availableProperties === void 0 ? void 0 : availableProperties.length) > 0;
  var notAvailablePropertiesExist = !isLoading && (notAvailableProperties === null || notAvailableProperties === void 0 ? void 0 : notAvailableProperties.length) > 0;
  var noOfferTypeAvailable = !availablePropertiesExist && !notAvailablePropertiesExist;
  var showNoAvailableOffersMessage = !isLoading && (!availablePropertiesExist && notAvailablePropertiesExist || noOfferTypeAvailable) && showFeedbackMessage && feedbackMessages.noAvailableOffersMessage;
  function renderLoadingPropertyCards(cardsAmount) {
    var cards = [];
    for (var i = 0; i < cardsAmount; i++) {
      cards.push(/*#__PURE__*/React__default.createElement(PropertyCard, {
        key: i.toString(),
        name: "Lorem ipsum",
        code: "Lorem ipsum ".concat(i),
        description: "Lorem ipsum",
        isLoading: true,
        displayMode: displayMode,
        alternativeGridMode: alternativeGrid,
        userCountry: userCountry,
        intl: intl
      }));
    }
    return cards;
  }
  var getTrustYouProfileById = function getTrustYouProfileById(id) {
    var _trustYou$id, _trustYou$id$profile;
    return id && ((_trustYou$id = trustYou[id]) === null || _trustYou$id === void 0 ? void 0 : (_trustYou$id$profile = _trustYou$id.profile) === null || _trustYou$id$profile === void 0 ? void 0 : _trustYou$id$profile.data);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-list\n                display-as-".concat(displayMode, "\n                display-with-").concat(propertiesListColumns, "-columns\n                ").concat(className, "\n            "),
    ref: rootRef
  }, isLoading ? renderLoadingPropertyCards(displayMode === 'list' ? 3 : 6) : null, availablePropertiesExist ? availableProperties.map(function (property) {
    var key = "PROPERTY_".concat(property.code);
    return /*#__PURE__*/React__default.createElement(PropertyCard, _extends({
      key: key
    }, propertyCardProps, property, {
      displayMode: displayMode,
      alternativeGridMode: alternativeGrid,
      onClick: onClick,
      params: params,
      domain: domain,
      getQueryString: getQueryString,
      trustYouProfile: getTrustYouProfileById(property.trustYouId),
      buttonMessage: feedbackMessages.buttonMessage,
      styledPrice: styledPrice,
      priceMessages: priceMessages,
      reviewsCountMessage: feedbackMessages.reviewsCountMessage,
      reviewsModalTitleMessage: feedbackMessages.reviewsModalTitleMessage,
      userCountry: userCountry,
      isQA: isQA,
      hidePrices: hidePrices,
      hidePricesMessage: hidePricesMessage,
      alternativeOffersLabels: alternativeOffersLabels,
      intl: intl
    }));
  }) : null, showNoAvailableOffersMessage ? /*#__PURE__*/React__default.createElement(EmptySectionMessage, {
    content: feedbackMessages.noAvailableOffersMessage,
    className: "bf-properties-list-full-width-element bf-properties-list-no-availability-message"
  }) : null, notAvailablePropertiesExist ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
    content: feedbackMessages.notAvailablePropertiesTitleMessage,
    size: "medium",
    className: "bf-properties-list-full-width-element bf-properties-list-no-available-properties-title"
  }), notAvailableProperties.map(function (property) {
    var key = "PROPERTY_".concat(property.code);
    return /*#__PURE__*/React__default.createElement(PropertyCard, _extends({
      key: key
    }, propertyCardProps, property, {
      displayMode: displayMode,
      alternativeGridMode: alternativeGrid,
      params: params,
      onClick: onClick,
      domain: domain,
      isNotAvailable: true,
      getQueryString: getQueryString,
      trustYouProfile: getTrustYouProfileById(property.trustYouId),
      buttonMessage: feedbackMessages.buttonMessage,
      reviewsCountMessage: feedbackMessages.reviewsCountMessage,
      reviewsModalTitleMessage: feedbackMessages.reviewsModalTitleMessage,
      userCountry: userCountry,
      isQA: isQA,
      intl: intl
    }));
  })) : null);
}
PropertiesList.defaultProps = {
  availableProperties: [],
  notAvailableProperties: [],
  className: '',
  displayMode: 'list',
  alternativeGrid: false,
  isLoading: false,
  showFeedbackMessage: false,
  domain: '',
  params: {},
  getQueryString: function getQueryString() {},
  onClick: function onClick() {},
  onPropertiesRendered: null,
  trustYou: null,
  styledPrice: false,
  isQA: false,
  hidePrices: false,
  hidePricesMessage: null
};
PropertiesList.propTypes = {
  /**
  Array of available properties
   */
  availableProperties: PropTypes.arrayOf(PropTypes.shape(multiPropertyOfferShape)),
  /**
  /**
  Array of not available properties
   */
  notAvailableProperties: PropTypes.arrayOf(PropTypes.shape(multiPropertyOfferShape)),
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
  Show properties in list, grid or map mode
   */
  displayMode: PropTypes.oneOf(['list', 'grid', 'map']),
  /**
  Specifies if alternative grid view should be shown instead of Booking Flow grid view
   */
  alternativeGrid: PropTypes.bool,
  /**
  Config props to propertyCard
   */
  propertyCardProps: PropTypes.shape({
    currency: PropTypes.shape(currencyShape).isRequired,
    currencyDisplay: PropTypes.string.isRequired,
    mapProvider: PropTypes.elementType.isRequired
  }).isRequired,
  /**
  Property in loading state
   */
  isLoading: PropTypes.bool,
  /**
  Allows to show feedback Message
   */
  showFeedbackMessage: PropTypes.bool,
  /**
  Intl feedback messages
   */
  feedbackMessages: PropTypes.shape(feedbackMessagesShape).isRequired,
  /**
  Site domain
   */
  domain: PropTypes.string,
  /**
  Url params
   */
  params: PropTypes.shape(formattedSearchParamsShape),
  /**
  Function helper to get the redirect url
   */
  getQueryString: PropTypes.func,
  /**
  Function triggered on property selection
   */
  onClick: PropTypes.func,
  /**
   * The property list can run a function, passing it the number of available rendered hotels
   */
  onPropertiesRendered: PropTypes.func,
  /**
  Dictionary of trustYou profiles and reviews
   */
  trustYou: PropTypes.objectOf(PropTypes.shape(trustYouReducerShape)),
  /**
  Show the price styled (currency, integer, decimal)
   */
  styledPrice: PropTypes.bool,
  /**
  Show the price messages
   */
  priceMessages: PropTypes.shape({
    startingFrom: nodeOrStringProp,
    priceDisplayMode: nodeOrStringProp
  }).isRequired,
  userCountry: PropTypes.string.isRequired,
  /**
   * This value is used for data-test-id
   */
  isQA: PropTypes.bool,
  hidePrices: PropTypes.bool,
  hidePricesMessage: PropTypes.node,
  alternativeOffersLabels: alternativeOffersLabelsShape.isRequired,
  intl: PropTypes.object.isRequired
};

export default PropertiesList;
